import { useAccountDataQuery } from '../queries/account';

export const useIsScarletFeatureEnabled = () => {
  const { data } = useAccountDataQuery();

  return data?.accountMeta?.features?.scarlet ?? false;
};
